export const errors = {
  cannotConnect: 'Error during connection process. Cannot connect.',
  cannotConnectTwoComponents:
    'Unable to connect two nodes with component type or two nodes with regular type.',
} as const
